import React from 'react';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';

const PALETTE = ['#E07A5F', '#7CA5B8', '#4A7C59', '#D4A373', '#B5838D', '#9C6644'];

function colorFor(name = '') {
    let hash = 0;
    for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
    return PALETTE[hash % PALETTE.length];
}

function initials(name = '') {
    return name.trim().split(/\s+/).slice(0, 2).map(n => n[0]?.toUpperCase()).join('') || '?';
}

export const UserAvatar = ({ name, picture, size = 40, className = '', ring = false }) => {
    const style = { width: size, height: size, backgroundColor: colorFor(name) };
    return (
        <Avatar
            className={`${className} ${ring ? 'ring-2 ring-white' : ''}`}
            style={{ width: size, height: size }}
        >
            {picture ? <AvatarImage src={picture} alt={name || 'user'} /> : null}
            <AvatarFallback style={style} className="text-white font-medium" data-testid="user-avatar-fallback">
                {initials(name)}
            </AvatarFallback>
        </Avatar>
    );
};

export default UserAvatar;
